import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function Tagessoll() {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();
  return (
    <form.AppField name="bezahlung.sollstunden.tagessoll">
      {(field) => (
        <field.HoursInput
          className="max-w-92"
          placeholder="hh:mm"
          suffix={t('general.date.hours')}
          maxHours={24}
          label={t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.tagessoll.label',
          )}
        />
      )}
    </form.AppField>
  );
}
